export default __webpack_public_path__ + "static/media/Recycling - Grey.e1881c51.svg";